import { Link, useLocation } from 'react-router-dom';
import { FOCUS_RING_CLASSES } from '../lib/focusTrap';
import { isNavActive, PRIMARY_NAV } from '../lib/nav';

/**
 * The mobile bottom tab bar (design review P1.1): the four primary surfaces,
 * permanently visible and thumb-reachable — no drawer hunt for daily
 * destinations. Hidden at `lg:` where the persistent sidebar takes over.
 * Sits above the home indicator via the safe-area padding.
 */
export function BottomTabBar() {
  const { pathname } = useLocation();

  return (
    <nav
      aria-label="Primary"
      data-testid="bottom-tab-bar"
      className="tab-bar lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-[var(--card-border)]"
    >
      <ul className="flex items-stretch justify-around">
        {PRIMARY_NAV.map((item) => {
          const Icon = item.icon;
          const active = isNavActive(item, pathname);
          return (
            <li key={item.id} className="flex-1">
              <Link
                to={item.path}
                aria-current={active ? 'page' : undefined}
                className={`flex min-h-[3.5rem] flex-col items-center justify-center gap-0.5 pt-1.5 pb-1 transition-colors ${FOCUS_RING_CLASSES} ${
                  active
                    ? 'text-[var(--accent-ink)]'
                    : 'text-[var(--text-tertiary)] hover:text-[var(--text-secondary)]'
                }`}
              >
                <Icon
                  className="w-6 h-6"
                  strokeWidth={active ? 2.4 : 2}
                  aria-hidden
                  fill={active && item.id === 'home' ? 'currentColor' : 'none'}
                />
                <span
                  className={`text-[11px] leading-tight ${active ? 'font-semibold' : 'font-medium'}`}
                >
                  {item.label}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
